import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { TooltipDialog } from '../../assessment-wrapper/tooltip-dialog/tooltip-dialog.component';
import { IndicatorQuestions } from '../models/indicator.model';


@Component({
    selector: 'app-indicator-question',
    templateUrl: './indicator-question.component.html',
    // styleUrls: ['./indicator-question.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class IndicatorQuestionComponent {
    @Input() dir;
    @Input() question: IndicatorQuestions;
    @Input() viewOnly: boolean;

    constructor(private dialog: MatDialog,
        private translateService: TranslateService) {

    }

    showDialog(message: string) {
        const dialogRef = this.dialog.open(TooltipDialog, {
            width: '80%',
            data: {
                dir: this.dir,
                message: this.translateService.instant(message)
            }
        });
    }

    checkValue(event) {
        if (this.question.answer < 0 || this.question.answer == null) this.question.answer = 0;
        event.target.value = this.question.answer;
    }
}
